import * as React from 'react';
import cx from 'classnames';

import './checkbox.styles.scss';

export type CheckboxProps = React.PropsWithChildren<{
  className?: string;
  label?: React.ReactNode;
  onChange?: (checked: boolean, params: { value: string | number; e: React.ChangeEvent<HTMLInputElement> }) => void; 
  classes?: {
    label?: string;
    input?: string;
  }
}> & Omit<React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'onChange'>;

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  const { label: labelContent, className, onChange, children, classes, ...otherProps } = props;

  const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.checked, { value: e.target.value, e });
    }
  }, [onChange]);
  
  return (
    <div 
      className={cx('checkbox Checkbox', className)} 
      title={typeof labelContent === 'string' || typeof labelContent === 'number' ? labelContent.toString() : undefined}
    >
      <label className={classes?.label}>
        <input 
          {...otherProps}
          className={classes?.input}
          type="checkbox"
          onChange={handleChange}
        />
        {labelContent || children}
      </label>
    </div>
  );
};

